import {React, StatePool, useEffect, useState} from '../../../../imports/imports-packege';
import PWAPreviewStyle from '../PWAPreviewStyle.module.css';
import {useData} from "../../../Context/ContextApp";
import IconStar from '../images/icon_star_blue.svg';
import IconStarGray from '../images/icon_star_gray.svg';
import IconPoint from '../images/icon_point.svg';
import BlockCommentQuestion from './BlockCommentQuestion';
import NameReviewer from '../FilePreviewAdditional/review_name-reviewers.json';
import ElementPageTranslate from '../Translate/text-translate.json';

const LangReview = StatePool.createState('');

const SectionReview = () => {
    const {data} = useData();
    const [reviewItems, setReviewItems] = useState([]);
    const [langReview, setLangReview] = StatePool.useState(LangReview);
    const handleLangReview = (langCode) => setLangReview(langCode);

    useEffect(() => {
        let codeLangReview = data['langCode'];
        handleLangReview(codeLangReview);
    }, [data]);

    const randomNumber = (min, max) =>  {
        let randomNumber = Math.random() * (max - min) + min;
        return randomNumber.toFixed(0);
    }

    const AddReview = () => {
        let DataReview = data.templateReview;
        let nameReviewer = !NameReviewer[data.langReviewSelect] ? NameReviewer['default'] : NameReviewer[data.langReviewSelect];
        let reviews = DataReview.map((text, index) => (
            <div key={index} className={PWAPreviewStyle.comment}>
                <div className={PWAPreviewStyle.comment__top}>
                    <div className={PWAPreviewStyle.comment__top_left}>
                        <p className={`${PWAPreviewStyle.comment__icon}`}>
                            <img src="images/ava_1.jpg" alt=""/>
                        </p>
                        <p className={PWAPreviewStyle.comment__title}>{nameReviewer[index + 1]}</p>
                    </div>
                    <div className={`${PWAPreviewStyle.menu}`}>
                        <img src={IconPoint} alt=""/>
                    </div>
                </div>

                <div className={PWAPreviewStyle.comment__stars}>
                    <div className={`${PWAPreviewStyle.stars} ${PWAPreviewStyle.stars__centering}`}>
                        {Array.from({length: 4}, (_, i) => (
                            <img key={i} className={PWAPreviewStyle.star__img} src={IconStar} alt=""/>
                        ))}
                        {Array.from({length: 1}, (_, i) => (
                            <img key={i} className={PWAPreviewStyle.star__img} src={IconStarGray} alt=""/>
                        ))}
                    </div>
                    <p className={`${PWAPreviewStyle.stars__data} ${PWAPreviewStyle.stars__data__centering}`}>05.03.24</p>
                </div>
                <div className={PWAPreviewStyle.comment__content}>
                    <p>{text}</p>
                </div>
                <p className={PWAPreviewStyle.comment_review}><span>{randomNumber(83, 184)}</span> {ElementPageTranslate[langReview]['review_text_count_like']}</p>
                <BlockCommentQuestion/>
            </div>
    ));
        setReviewItems(reviews);
    }

    useEffect(() => {
        AddReview(langReview);
    }, [data]);

    return (
        <section className={`${PWAPreviewStyle.comments}`}>
            {reviewItems}
        </section>
    );
};

export default SectionReview;
